module.exports = __webpack_public_path__ + "static/media/instagram.f8c2870f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/FixedIcons/assets/instagram.svg
// module id = 68
// module chunks = 0